import React from 'react'
type Props = {
  data: Record<string, any>
}

const Component = ({ data }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { name, title, blurb, showCaseImage } = data
  return (
    <div data-section='showcase'>
      <img
        className='lazyload'
        loading='lazy'
        width='700'
        height='720'
        data-src={showCaseImage}
        alt={`Saatchi For The Trade - ${name}`}
        itemProp='image'
      />

      <div data-type='bio'>
        <div data-section='content'>
          <p data-type='callout'>
            Meet Our <span data-type='teamSplit'>Senior Advisory Team</span>
          </p>
          <p data-type='rule' />
          <img
            className='lazyload'
            loading='lazy'
            width='700'
            height='720'
            data-src={showCaseImage}
            alt={`Saatchi For The Trade - ${name}`}
            itemProp='image'
          />
          <p data-type='name'>{name}</p>
          <p data-type='title'>{title}</p>
          <p data-type='blurb'>{blurb}</p>
        </div>
      </div>
    </div>
  )
}

export default Component